export default "__VITE_ASSET__3995cd85__"